import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { MapPin, Mail } from "lucide-react";
import ContactSection from "@/components/ContactSection";
import WriteToUsSection from "@/components/WriteToUsSection";

/**
 * Merges the homepage "Visit our studio" (contact) and "Write to us"
 * (enquiry) sections into a single section with two tabs. Forms,
 * validation, API calls and styling for each tab are reused as-is from
 * their original components via the `embedded` prop.
 */
export default function ContactTabbedSection() {
    return (
        <section
            id="contact"
            className="py-20 md:py-28 bg-paper-alt"
            data-testid="contact-tabbed-section"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Tabs defaultValue="studio" className="w-full">
                    <TabsList
                        className="mx-auto bg-white border border-gray-100 p-1.5 rounded-full flex w-fit h-auto gap-1 mb-10 md:mb-14"
                        data-testid="contact-tabs-list"
                    >
                        <TabsTrigger
                            value="studio"
                            className="rounded-full data-[state=active]:bg-brand-500 data-[state=active]:text-white px-5 py-2 text-sm font-medium inline-flex items-center gap-2"
                            data-testid="contact-tab-studio"
                        >
                            <MapPin className="h-4 w-4" strokeWidth={1.8} />
                            Visit our studio
                        </TabsTrigger>
                        <TabsTrigger
                            value="write"
                            className="rounded-full data-[state=active]:bg-brand-500 data-[state=active]:text-white px-5 py-2 text-sm font-medium inline-flex items-center gap-2"
                            data-testid="contact-tab-write"
                        >
                            <Mail className="h-4 w-4" strokeWidth={1.8} />
                            Write to us
                        </TabsTrigger>
                    </TabsList>

                    <TabsContent value="studio" className="mt-0">
                        <ContactSection embedded />
                    </TabsContent>
                    <TabsContent value="write" className="mt-0">
                        <WriteToUsSection embedded />
                    </TabsContent>
                </Tabs>
            </div>
        </section>
    );
}
